<template>
  <sui-segment raised style="margin: 0px auto; max-width: 450px;">
    
         <h2 sui-header align="center">{{ $t('headerlabel') }}</h2>
    
        <sui-container text tyle="margin: 0px auto; max-width: 450px;">
    <div class="middle aligned center aligned ui stackable grid">   
    <div class="column">   
        <sui-form style="max-width:420px;">
        <sui-segment>
                <div class="field">
            <label></label>
                    <sui-input v-model="input.username" name="username" icon-position="left" icon="user icon" :placeholder="$t('labelUsername')">
                    </sui-input></div>
                    <label> </label>
                     <sui-message error :visible="userhasError">
                       <p>{{$t('errorUser')}}</p>
                     </sui-message>        
        <div class="field">
            <label> </label>
                <sui-input v-model="input.password"  type="password" icon-position="left" icon="lock icon" name="password" :placeholder="$t('labelPassword')">
                </sui-input></div>
                    <label> </label>
                     <sui-message error :visible="passhasError">
                       <p>{{$t('errorPass')}}</p>
                     </sui-message>        
                     <sui-message error :visible="loginError">
                       <p>{{$t('confirmpassError')}}</p>
                     </sui-message>
        <div class="field">
            <label> </label>
                <sui-input v-model="input.newpassword"  type="password" icon-position="left" icon="lock icon" name="newpassword" :placeholder="$t('labelNewPassword')">
                </sui-input></div>
                    <label> </label>
                     <sui-message error :visible="newpasshasError">
                       <p>{{$t('errorPass')}}</p>
                     </sui-message>
                    <label> </label>
                     <sui-message error :visible="newpassError2">
                       <p>{{$t('errornewPass')}}</p>
                     </sui-message>
                     <sui-message error :visible="newpassError3">
                       <p>{{$t('errornewPass2')}}</p>
                     </sui-message>
        <div class="field">
            <label> </label>
                <sui-input v-model="input.confirmpassword"  type="password" icon-position="left" icon="lock icon" name="confirmpassword" :placeholder="$t('labelConfirmPassword')">
                </sui-input></div>
                    <label> </label>
                     <sui-message error :visible="confirmpasshasError">
                       <p>{{$t('errorPass')}}</p>
                     </sui-message>
                     <sui-message error :visible="confirmpassError2">
                       <p>{{$t('confirmpassError')}}</p>
                     </sui-message>
        <div class="ui red fluid button" v-on:click="login()">{{ $t('sendLabel')}}</div>
         </sui-segment>
        </sui-form>
         <sui-segment v-if="success" align="center" style="max-width:420px;" color="green">
        <sui-form style="max-width:420px;">
          <div class="field">
            <h3 class="successItem">{{ $t('changeSuccess')}}</h3>
         <!--   <sui-message :visible="shownewpass">
              <p>{{this.input.newpassword}}</p>
            </sui-message>
              <div class="ui red fluid button" v-on:click="showpass">Show new Password</div>-->
          </div>
        </sui-form>
         </sui-segment>

        </div>
    </div>
        </sui-container>
            <label> </label>
        <sui-message align="center">
        <div class="sui button" style="cursor: pointer;" v-on:click="back">{{ $t('backtoLogin') }}</div>
        </sui-message>
        <sui-dimmer :active="loading">
           <sui-loader>{{ $t('strLoading') }}</sui-loader>
        </sui-dimmer>
  </sui-segment>
</template>


<script>
import ApiService from '@/services/ApiService.js';

  export default {
    name: 'changePassword',
    metaInfo() {
      return {
        title: 'LAN1 Status Check',
      }
    },
    data() {
      return {
        userhasError: false,
        passhasError: false,
        newpasshasError: false,
        confirmpasshasError: false,
        confirmpassError2: false,
        newpassError2: false,
        loading: false,
        success: false,
        loginError: false,
        shownewpass: false,
        changesuccess: false,
        newpassError3: false,
        input: {
          username: "",
          password: "",
          newpassword: "",
          confirmpassword: "",

        }
      }
    },
    methods: {
      async login() {
          
        this.userhasError = (this.input.username == "") ? true : false;
        this.passhasError = (this.input.password == "") ? true : false;
        this.newpasshasError = (this.input.newpassword == "") ? true : false;
        this.newpassError2 = (this.input.newpassword == this.input.password) ? true: false;
        this.confirmpasshasError = (this.input.confirmpassword == "") ? true : false; 
        this.confirmpassError2 = (this.input.confirmpassword != this.input.newpassword) ? true : false;
        this.newpassError3 = (this.input.newpassword.length < 5) ? true : false;

      if(this.userhasError == false && this.passhasError == false && this.newpasshasError == false && this.confirmpasshasError == false && this.confirmpassError2 == false && this.newpassError2 == false && this.newpassError3 == false){
          this.loading = true;   
          let changeresponse = await ApiService.postPasswordRequest({username: this.input.username, password1: this.input.password, password2: this.input.newpassword, password3: this.input.confirmpassword});
          this.loading = false;
          if(changeresponse.status == 200){
            this.changesuccess = changeresponse.data.success
            if(this.changesuccess != true){
                this.loginError = true;
                this.input.password = "";
                this.input.newpassword = "";
                this.input.confirmpassword = "";
                this.success = null;
                
            }else{
                this.success = true;
                this.loginError = null;
            }

          }


      }else{
        this.input.password = "";
        this.input.newpassword = "";
        this.input.confirmpassword = "";
        if(this.newpasshasError == true) {
          this.newpassError2 = false;
          this.newpassError3 = false;
        }else if(this.newpassError2 == true) {
          this.newpassError3 = false;
        }
        if(this.confirmpasshasError == true) {
          this.confirmpassError2 = false;
        }
      }

      },
      back() {
        this.$router.push("/");
      }
    },

    

  }
</script>



<style lang="scss" scoped>
  h1{
    display: none;
  }
</style>
